// ============================================================================
// Table Columns: Absences
// Key: absences
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type { AbsenceDetails } from '../api/backstage.schemas'
import { AbsenceReason, RecurrenceInterval } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const absencesListColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		cellRenderer('start', 'dateTime'),
		cellRenderer('end', 'dateTime'),
		enumRenderer('reason', AbsenceReason, 'AbsenceReason'),
		enumRenderer(
			'recurrenceInterval',
			RecurrenceInterval,
			'RecurrenceInterval',
		),
		cellRenderer('recurrenceEnd', 'dateTime'),
		cellRenderer('teams', 'list'),
		'userFirstName',
		'userLastName',
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: AbsenceDetails) => `/absences/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<AbsenceDetails>
// #endregion

// #region Columns Config Export
export const absencesColumnsConfig = {
	list: absencesListColumnsConfig,
} as const
// #endregion
